import WoundAge from './WoundAge';

export default WoundAge;
